<template>
  <div class="youtube-embed">
    <iframe
      v-if="videoId"
      :src="`https://www.youtube.com/embed/${videoId}`"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <p v-else>Link YouTube non valido</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
})

// Funzione per estrarre l'ID da vari formati di link YouTube
const extractYouTubeId = (url) => {
  if (!url) return null
  const regex =
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/
  const match = regex.exec(url)
  return match ? match[1] : null
}

const videoId = computed(() => extractYouTubeId(props.url))
</script>

<style scoped>
.youtube-embed {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  overflow: hidden;
  max-width: 100%;
  margin-top: 4rem;
}

.youtube-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>